export const API_URL = 'https://api.toursbouillon.fr/api'; 

// local : http://localhost:3001/api
// PROD export const API_URL = 'https://api.toursbouillon.fr/api'; 